<template>
    <div>
        <form class="form-edit-account"
              name="edit_corporation"
              novalidate
              @submit.prevent="saveAmsCustomerDetail"
              v-if="storeState.fetchDataSuccess"
        >
            <div class="row">
                <div class="col-sm-10 col-md-10 offset-sm-1 offset-md-1">
                    <div class="form-group row">
                        <label class="control-label col-sm-3">{{ $t('profile.label.account_id') }}</label>
                        <div class="col-sm-8">
                            <p class="">{{ customerInfoView.customerId }}</p>
                        </div>
                    </div>

                    <div class="form-group row" v-show="storeState.hasNtdAccount">
                        <label class="control-label col-sm-3">{{ $t('profile.label.ntd_account') }}</label>
                        <div class="col-sm-8">
                            <p class="">{{ storeState.ntdAccount.ntdAccountId }}</p>
                        </div>
                    </div>

                    <div class="row row-cols-1 accordion" aria-multiselectable="true" id="accordion">
                        <!-- start block CUSTOMER_PASSWORD -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_PASSWORD'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.password') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">*******</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm btn-primary btn-change-password"
                                            @click="updateBlockInfo('CUSTOMER_PASSWORD')">
                                            <span class="show-edit">
                                                {{ $t('profile.label.change') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_PASSWORD'?'show':''">
                                <UpdatePwd
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_PASSWORD"
                                    :storeState="storeState"
                                    :maskingVerifiedPerSession="maskingVerifiedPerSession"
                                    toggleButtonType="CUSTOMER_PASSWORD">
                                </UpdatePwd>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_PASSWORD -->
                        <!-- start block CUSTOMER_CORP_NAME -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_CORP_NAME'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{
                                            $t('profile.label.corp.real_name')
                                        }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ storeState.input["amsCustomerDetail.corporationName"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_CORP_NAME')" :disabled="!maskingVerifiedPerSession">
                                                <span
                                                    class="show-edit">
                                                    {{ $t('profile.label.change') }}
                                                </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_CORP_NAME'?'show':''">
                                <UpdateCustomerName
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_CORP_NAME"
                                    toggleButtonType="CUSTOMER_CORP_NAME">
                                </UpdateCustomerName>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_CORP_NAME -->
                        <!-- start block CUSTOMER_ADDRESS -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_ADDRESS'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.corp.label.address') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ storeState.input["amsCustomerDetail.address"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_ADDRESS')" :disabled="!maskingVerifiedPerSession">
                                            <span
                                                class="show-edit">
                                                {{ $t('profile.label.change') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_ADDRESS'?'show':''">
                                <UpdateCustomerAddress
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_ADDRESS"
                                    toggleButtonType="CUSTOMER_ADDRESS">
                                </UpdateCustomerAddress>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_ADDRESS -->
                        <!-- start block CUSTOMER_PHONE -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_PHONE'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.phone_number') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ storeState.input["amsCustomerDetail.phone"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_PHONE')" :disabled="!maskingVerifiedPerSession">
                                            <span
                                                class="show-edit">
                                                {{ $t('profile.label.change') }}
                                             </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_PHONE'?'show':''">
                                <UpdatePhone
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_PHONE"
                                    toggleButtonType="CUSTOMER_PHONE">
                                </UpdatePhone>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_PHONE -->
                        <!-- start block CUSTOMER_REP_NAME -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_REP_NAME'">
                                <div class="form-group row">
                                    <label
                                        class="control-label col-sm-3">{{ $t('profile.label.representatives_name') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ storeState.input["amsCustomerDetail.repFullName"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_REP_NAME')" :disabled="!maskingVerifiedPerSession">
                                            <span
                                                class="show-edit">
                                                {{ $t('profile.label.change') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_REP_NAME'?'show':''">
                                <UpdateCustomerRepName
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_REP_NAME"
                                    toggleButtonType="CUSTOMER_REP_NAME">
                                </UpdateCustomerRepName>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_REP_NAME -->
                        <!-- start block CUSTOMER_BENEFIC_NAME -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_BENEFIC_NAME'">
                                <div class="form-group row">
                                    <label
                                        class="control-label col-sm-3">{{ $t('profile.label.existence_benefic_owner') }}</label>
                                    <div class="col-sm-6" v-if="!maskingVerifiedPerSession">
                                        <p class="">*****</p>
                                    </div>
                                    <div class="col-sm-6" v-else>
                                        <p class="">{{ beneficOwnerViewLabel }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_BENEFIC_NAME')" :disabled="!maskingVerifiedPerSession">
                                            <span
                                                class="show-edit">{{ $t('profile.label.change') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_BENEFIC_NAME'?'show':''">
                                <UpdateCustomerBeneficName
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    :isVisible="!maskingVerifiedPerSession"
                                    ref="CUSTOMER_BENEFIC_NAME"
                                    toggleButtonType="CUSTOMER_BENEFIC_NAME">
                                </UpdateCustomerBeneficName>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_BENEFIC_NAME -->
                        <!-- start block CUSTOMER_PIC_NAME -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_PIC_NAME'">
                                <div class="form-group row">
                                    <label
                                        class="control-label col-sm-3">{{ $t('profile.label.person_in_charge_name') }}</label>
                                    <div class="col-sm-6">
                                        <!-- space fullsize => not delete or update -->
                                        <p class="">{{ input["amsCustomerDetail.picLastName"] + "　" + input["amsCustomerDetail.picFirstName"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_PIC_NAME')" :disabled="!maskingVerifiedPerSession">
                                            <span
                                                class="show-edit">{{ $t('profile.label.change') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_PIC_NAME'?'show':''">
                                <UpdateCustomerPicName
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_PIC_NAME"
                                    toggleButtonType="CUSTOMER_PIC_NAME">
                                </UpdateCustomerPicName>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_PIC_NAME -->
                        <!-- start block CUSTOMER_PIC_ADDRESS -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_PIC_ADDRESS'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.pic_address') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ input["amsCustomerDetail.picAddress"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_PIC_ADDRESS')" :disabled="!maskingVerifiedPerSession">
                                            <span
                                                class="show-edit">{{ $t('profile.label.change') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_PIC_ADDRESS'?'show':''">
                                <UpdateCustomerPicAddress
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_PIC_ADDRESS"
                                    toggleButtonType="CUSTOMER_PIC_ADDRESS">
                                </UpdateCustomerPicAddress>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_PIC_ADDRESS -->
                        <!-- start block CUSTOMER_PIC_PHONE -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_PIC_PHONE'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.pic_phone') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ input["amsCustomerDetail.picPhone"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button
                                            type="button"
                                            class="btn-toggle-edit btn btn-sm"
                                            :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                            @click="updateBlockInfo('CUSTOMER_PIC_PHONE')" :disabled="!maskingVerifiedPerSession">
                                            <span class="show-edit">{{ $t('profile.label.change') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_PIC_PHONE'?'show':''">
                                <UpdatePicPhone
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_PIC_PHONE"
                                    toggleButtonType="CUSTOMER_PIC_PHONE">
                                </UpdatePicPhone>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_PIC_PHONE -->
                        <!-- start block CUSTOMER_MAIN_MAIL -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_MAIN_MAIL'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.email') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ input["amsCustomerDetail.email"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm"
                                                :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                                @click="updateBlockInfo('CUSTOMER_MAIN_MAIL')" :disabled="!maskingVerifiedPerSession">
                                                              <span class="show-edit">
                                                                  {{ $t('profile.label.change') }}
                                                              </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_MAIN_MAIL'?'show':''">
                                <UpdateMail
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_MAIN_MAIL"
                                    toggleButtonType="CUSTOMER_MAIN_MAIL">
                                </UpdateMail>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_MAIN_MAIL -->
                        <!-- start block CUSTOMER_ADDITIONAL_MAIL -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_ADDITIONAL_MAIL'">
                                <div class="form-group row">
                                    <label
                                        class="control-label col-sm-3">{{ $t('profile.label.additional_email') }}</label>
                                    <div class="col-sm-6">
                                        <p class="">{{ input["amsCustomerDetail.additionalEmail"] }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm"
                                                :class="{'btn-disabled-masking' : !maskingVerifiedPerSession, 'btn-primary' : maskingVerifiedPerSession}"
                                                @click="updateBlockInfo('CUSTOMER_ADDITIONAL_MAIL')"
                                                :disabled="!maskingVerifiedPerSession">
                                                        <span class="show-edit">
                                                            {{ $t('profile.label.change') }}
                                                        </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_ADDITIONAL_MAIL'?'show':''">
                                <UpdateAdditionalMail
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    :hasAdditionEmail="storeState.hasAdditionEmail"
                                    ref="CUSTOMER_ADDITIONAL_MAIL"
                                    toggleButtonType="CUSTOMER_ADDITIONAL_MAIL">
                                </UpdateAdditionalMail>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_ADDITIONAL_MAIL -->
                        <!-- start block SEND_MAIL_INFORMATION block -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='SEND_MAIL_INFO'">
                                <div class="form-group row">
                                    <label
                                        class="control-label col-sm-3">{{ $t('profile.label.sendMailInfoFlg') }}</label>
                                    <div class="col-sm-6">
                                        <p v-if="input['amsCustomerDetail.sendMailInfoFlg'] == 0">
                                            {{ $t('profile.label.sendMailInfoFlg.inactive') }}
                                        </p>
                                        <p v-if="input['amsCustomerDetail.sendMailInfoFlg'] == 1">
                                            {{ $t('profile.label.sendMailInfoFlg.active') }}
                                        </p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm btn-primary"
                                                @click="updateBlockInfo('SEND_MAIL_INFO')">
                                            <span class="show-edit">{{ $t('profile.label.change') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='SEND_MAIL_INFO'?'show':''">
                                <SendMailInformation
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="SEND_MAIL_INFO"
                                    toggleButtonType="SEND_MAIL_INFO">
                                </SendMailInformation>
                            </div>
                        </div>
                        <!-- end block SEND_MAIL_INFORMATION block -->
                        <!-- start block CUSTOMER_SELF_ASSET -->
                        <div class="form-group-box card">
                            <div class="form-group-main financial-assets-custom" v-if="activeBlock!=='CUSTOMER_SELF_ASSET'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">
                                        {{ $t('profile.label.financial_assets') }}
                                        <span id="tooltip-financial-assets" title="">
                                          <i id="fa-question-circle-financial-assets" class="fa fa-question-circle" style="font-size: 12px"></i>
                                          <div class="tooltipbig-wrapper-financial-assets">
                                            <div class="tooltip-note" style="color: red;">
                                              <span>{{$t('tooltip.financial_assets')}}</span><br/>
                                            </div>
                                          </div>
                                        </span>
                                    </label>
                                    <div class="col-sm-6">
                                        <p>{{ getFinancialAssetsLabel }}</p>
                                    </div>
                                    <div class="col-sm-2 financial-investment-edit-btn">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm btn-primary"
                                                @click="updateBlockInfo('CUSTOMER_SELF_ASSET')">
                                            <span class="show-edit">{{ $t('profile.label.change') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_SELF_ASSET'">
                              <div class="form-group row">
                                <label class="control-label col-sm-3">
                                  {{ $t('profile.label.investment_amount') }}
                                  <span id="tooltip-investment-amount" title="">
                                              <i id="fa-question-circle-investment-amount" class="fa fa-question-circle" style="font-size: 12px"></i>
                                              <div class="tooltipbig-wrapper-investment-amount">
                                                  <div class="tooltip-note" style="color: red;">
                                                      <span>{{$t('tooltip.investment_amount')}}</span><br/>
                                                  </div>
                                              </div>
                                          </span>
                                </label>
                                <div class="col-sm-6">
                                  <p>{{ getInvestmentAmountLabel }}</p>
                                </div>
                              </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_SELF_ASSET'?'show':''">
                                <UpdateSelfAsset
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_SELF_ASSET"
                                    toggleButtonType="CUSTOMER_SELF_ASSET">
                                </UpdateSelfAsset>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_SELF_ASSET -->
                        <!-- start block CUSTOMER_FX_INVEST -->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='CUSTOMER_FX_INVEST'">
                                <div class="form-group row">
                                    <label
                                        class="control-label col-sm-3">{{ $t('profile.label.investment_purposes') }}</label>
                                    <div class="col-sm-6">
                                        <p v-html="getInvestmentViewText"></p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm btn-primary"
                                                @click="updateBlockInfo('CUSTOMER_FX_INVEST')">
                                            <span class="show-edit">{{ $t('profile.label.change') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='CUSTOMER_FX_INVEST'?'show':''">
                                <UpdateFxInvestPurpose
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="CUSTOMER_FX_INVEST"
                                    toggleButtonType="CUSTOMER_FX_INVEST">
                                </UpdateFxInvestPurpose>
                            </div>
                        </div>
                        <!-- end block CUSTOMER_FX_INVEST -->

                        <div v-if="storeState.isEaAccount === 1">
                            <div class="form-group row" v-if="storeState.hasSocialAccount">
                                <label
                                    class="control-label col-sm-3">{{ $t('profile.label.account_open_date') }}</label>
                                <div class="col-sm-6">
                                    <p class="">
                                        {{ storeState.socialAccount.accountOpenDate  | formatDate('YYYYMMDD',formatData) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div v-if="storeState.isEaAccount === 0">
                            <div class="form-group row" v-if="storeState.hasNtdAccount">
                                <label
                                    class="control-label col-sm-3">{{ $t('profile.label.account_open_date') }}</label>
                                <div class="col-sm-6">
                                    <p class="">
                                        {{ storeState.ntdAccount.accountOpenDate  |formatDate('YYYYMMDD',formatData) }}
                                    </p>
                                </div>
                            </div>
                        </div>


                        <!-- start upload my number area-->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='MY_NUMBER_UPLOAD'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.my_number.corporation') }}</label>
                                    <div class="col-sm-6">
                                        <div v-if="storeState.customerInfoView.myNumberStatus === 0">
                                            <p>{{ $t('profile.label.my_number.unregistered') }}</p>
                                        </div>
                                        <div v-else-if="storeState.customerInfoView.myNumberStatus === 1">
                                            <p>{{ $t('profile.label.my_number.registered') }}</p>
                                        </div>
                                        <div v-else-if="storeState.customerInfoView.myNumberStatus === 2">
                                            <p>{{ $t('profile.label.my_number.delete') }}</p>
                                        </div>
                                    </div>
                                    <div class="col-sm-2" v-if="storeState.customerInfoView.myNumberStatus === 0">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm btn-primary"
                                                @click="updateBlockInfo('MY_NUMBER_UPLOAD')">
                                            <span class="show-edit">{{ $t('profile.label.upload') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='MY_NUMBER_UPLOAD'?'show':''">
                                <UpdateMyNumber
                                    parentScreen="edit-profile"
                                    :inputProp="input"
                                    ref="MY_NUMBER_UPLOAD"
                                    toggleButtonType="MY_NUMBER_UPLOAD"
                                    blockInfo="MY_NUMBER_UPLOAD"
                                    v-on:myNumberUploadInputEmpty="showErrorMsg('MSG_TRS_NAF_0087')"
                                >
                                </UpdateMyNumber>
                            </div>
                        </div>
                        <!-- end upload my number area-->

                      <!-- start upload id document area-->
                      <div class="form-group-box card">
                        <div class="form-group-main" v-if="activeBlock!=='DOCUMENT_ID_UPLOAD'">
                          <div class="form-group row">
                            <label class="control-label col-sm-3">{{ $t('profile.label.id.document.upload') }}</label>
                            <div class="col-sm-6"></div>
                            <div class="col-sm-2">
                              <button type="button"
                                      class="btn-toggle-edit btn btn-sm btn-primary"
                                      @click="updateBlockInfo('DOCUMENT_ID_UPLOAD')">
                                <span class="show-edit">{{ $t('profile.label.upload') }}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="collapse" :class="activeBlock==='DOCUMENT_ID_UPLOAD'?'show':''">
                          <UploadIdDocument
                              parentScreen="edit-profile"
                              :inputProp="input"
                              ref="DOCUMENT_ID_UPLOAD"
                              toggleButtonType="DOCUMENT_ID_UPLOAD"
                              blockInfo="DOCUMENT_ID_UPLOAD"
                              v-on:UploadIdDocumentInputEmpty="showErrorMsg('MSG_TRS_NAF_0087')"
                          >
                          </UploadIdDocument>
                        </div>
                      </div>
                      <!-- end upload id document area-->
                        <div
                            style="margin: 20px 0px;font-weight: bold;border-bottom: dotted 1px #ccc;padding-bottom: 5px;font-size: 14px;">
                            {{ $t('profile.label.security.setting') }}
                        </div>
                        <!--START: REGISTERED_PASSKEYS-->
                        <div class="form-group-box card overflow-visible">
                            <div class="form-group-main" v-if="activeBlock!=='REGISTERED_PASSKEYS'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3 customer-two-fa-label">
                                        {{ $t('profile.label.fido.passkey.registration.label') }}
                                    </label>
                                    <div class="col-sm-6">
                                        <p>{{ getPasskeyStatusLabel }}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm btn-primary"
                                                @click="updateBlockInfo('REGISTERED_PASSKEYS')">
                                            <span class="show-edit">{{ $t('profile.label.change') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='REGISTERED_PASSKEYS'?'show':''">
                                <RegisteredPasskeys
                                        parentScreen="edit-profile"
                                        :inputProp="input"
                                        ref="REGISTERED_PASSKEYS"
                                        toggleButtonType="REGISTERED_PASSKEYS">
                                </RegisteredPasskeys>
                            </div>
                        </div>
                        <!--END: REGISTERED_PASSKEYS-->
                        <!--START: LOGIN_NOTIFY-->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='LOGIN_NOTIFY'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.login_notify.title') }}</label>
                                    <div class="col-sm-6">
                                        <p v-for="title in loginNotifyTitleList" :key="title">
                                            {{ $t(title) }}
                                        </p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm btn-primary"
                                                @click="updateBlockInfo('LOGIN_NOTIFY')">
                                            <span class="show-edit">{{ $t('profile.label.change') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='LOGIN_NOTIFY'?'show':''">
                                <UpdateLoginNotify
                                        parentScreen="edit-profile"
                                        :inputProp="input"
                                        ref="LOGIN_NOTIFY"
                                        toggleButtonType="LOGIN_NOTIFY">
                                </UpdateLoginNotify>
                            </div>
                        </div>
                        <!--END: LOGIN_NOTIFY-->
                        <!--START: ALERT_AUTH_FLG-->
                        <div class="form-group-box card">
                            <div class="form-group-main" v-if="activeBlock!=='ALERT_AUTH_FLG'">
                                <div class="form-group row">
                                    <label class="control-label col-sm-3">{{ $t('profile.label.fido.authentication.alert') }}</label>
                                    <div class="col-sm-6">
                                        <p v-for="title in alertAuthenticateTitleList" :key="title">
                                            {{ $t(title) }}
                                        </p>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button"
                                                class="btn-toggle-edit btn btn-sm btn-primary"
                                                @click="updateBlockInfo('ALERT_AUTH_FLG')">
                                            <span class="show-edit">{{ $t('profile.label.change') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" :class="activeBlock==='ALERT_AUTH_FLG'?'show':''">
                                <AuthenticateAlert
                                        parentScreen="edit-profile"
                                        :inputProp="input"
                                        ref="ALERT_AUTH_FLG"
                                        toggleButtonType="ALERT_AUTH_FLG">
                                </AuthenticateAlert>
                            </div>
                        </div>
                        <!--END: ALERT_AUTH_FLG-->
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import preparedDataInput from '@/common/mixins/preparedDataInput'
    import EditProfileMixins from "@/common/mixins/EditProfileMixins";
    export default {
        props: ['storeState', 'maskingVerifiedPerSession'],
        mixins: [preparedDataInput, EditProfileMixins],
        computed: {
            beneficOwnerViewLabel() {
                const storeState = {...this.storeState};
                let result = "";
                if (storeState.customerInfoView.beneficOwnerFlg) {
                    result = this.$options.filters.getByProperty('key', storeState.customerInfoView.beneficOwnerFlg, this.IConstants.listBeneficOwner).value;
                }
                return result;
            }
        }
    }
</script>
<style scoped>
    form, input[type="button"] {
        margin: 0 !important
    }
</style>